import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@aveva/connect-web-core';
import { Observable } from 'rxjs';

@Injectable()
export class UnauthorizedGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.getUser()
      .then((user) => {
        if (!user) {
          this.authenticationService.navigateToSignIn();
          return false;
        }
        return true;
      });
  }
}
